var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 64",
    style: {
      enableBackground: "new 0 0 72 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C4171E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x23_c4171eff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,26.9c0.4-0.4,0.9-0.6,1.4-0.6c1.6,0,3.3,0,4.9,0c0,3.7,0,7.5,0,11.2c-1.2,0-2.3,0-3.5,0 c0-2.8,0-5.7,0-8.5c-1.4,2.8-2.7,5.7-4.1,8.5c-1.2,0-2.5,0-3.7,0c1.5-3.3,3-6.5,4.5-9.8C21.3,27.5,21.4,27.2,21.7,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.1,27.5c0-0.6,0.5-1.2,1-1.1c1.2,0,2.4,0,3.6,0c-0.2,0.1-0.4,0.1-0.6,0.3c-0.2,0.2-0.1,0.5-0.1,0.7 c0.1,0.4,0.4,0.7,0.6,1.1c0.7,0.9,1.4,1.8,2.1,2.7c0.6,0.7,1.1,1.5,1.3,2.5c0.2,0.9,0,1.9-0.5,2.6c-0.4,0.6-1,1-1.6,1.1 c-0.5,0.1-1,0.1-1.5,0.1c-1.9,0-3.7,0-5.6,0c0-0.9,0-1.7,0-2.6c1.2,0,2.4,0,3.7,0c0.4,0,0.9,0,1.3-0.2c0.4-0.2,0.6-0.7,0.5-1.1 c-0.2-0.5-0.5-0.8-0.8-1.2c-0.9-1.1-1.7-2.2-2.6-3.3C30.5,28.7,30.1,28.1,30.1,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.2,27.1c0.1-0.4,0.6-0.7,1-0.7c0.8,0,1.6,0,2.3,0c0,3.7,0,7.5,0,11.2c-1.2,0-2.3,0-3.5,0c0-3.2,0-6.5,0-9.7 C39.2,27.7,39.2,27.4,39.2,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,26.9c0.4-0.4,0.9-0.6,1.4-0.5c1.5,0,3,0,4.5,0c0,3.7,0,7.5,0,11.2c-1.2,0-2.3,0-3.5,0c0-2.8,0-5.5,0-8.3 c-1.3,2.8-2.5,5.5-3.7,8.3c-1.2,0-2.4,0-3.7,0c1.5-3.2,2.9-6.5,4.4-9.7C48.4,27.6,48.6,27.2,48.8,26.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsea);
export default __webpack_public_path__ + "static/media/asea.d8c373c0fa1cf4052400c247e16f6600.svg";
export { ForwardRef as ReactComponent };